import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CopyClipboardDirective } from "./copy-clipboard.directive";
import { ClearFieldIfDirective } from "./clear-field-if.directive";
import { EnsureMinValueDirective } from "./ensure-min-value";
import { SkeletonDirective } from "./skeleton-loader.directive";
import { ScrollOnFocusDirective } from "app/directives/scroll-on-focus.directive";
import { CanShowDirective } from "./can-show.directive";
import { UNgxSummernoteDirective } from "./customsummernote/usummernote.directive";
import { UNgxSummernoteViewDirective } from "./customsummernote/usummernote-view.directive";
import { IntegerOnlyDirective } from "./integer-only.directive";
import { OverflowTooltipDirective } from "./overflow-tooltip.directive";
import { HasStockFeatureDirective } from "./has-stock-feature.directive";
import { CaretAtEndDirective } from "./caret-at-end.directive";
import { InfoTipDirective } from "./info-tip.directive";

@NgModule({
    declarations: [
        CanShowDirective,
        CopyClipboardDirective,
        ClearFieldIfDirective,
        EnsureMinValueDirective,
        SkeletonDirective,
        ScrollOnFocusDirective,
        UNgxSummernoteDirective,
        UNgxSummernoteViewDirective,
        IntegerOnlyDirective,
        OverflowTooltipDirective,
        HasStockFeatureDirective,
        CaretAtEndDirective,
        InfoTipDirective
    ],
    exports: [
        CanShowDirective,
        CopyClipboardDirective,
        ClearFieldIfDirective,
        EnsureMinValueDirective,
        SkeletonDirective,
        ScrollOnFocusDirective,
        UNgxSummernoteDirective,
        UNgxSummernoteViewDirective,
        IntegerOnlyDirective,
        OverflowTooltipDirective,
        HasStockFeatureDirective,
        CaretAtEndDirective,
        InfoTipDirective
    ],
})
export class DirectivesModule {
    static forRoot() {
        return {
            ngModule: DirectivesModule,
            providers: [],
        };
    }
}
